import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=4dc3b98a"
import script from "./ComponentList.vue?vue&type=script&lang=js"
export * from "./ComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports